import React, { Component } from 'react'
import statisticsIcon from "app/styles/images/sp/statistics-selected.svg"
import { observer } from "mobx-react"
import Store from "app/stores/research/azf/statistics"
import DataHeader from './containers/DataHeader'
import DataTable from './containers/DataTable'
import './Index.scss'

@observer
export default class index extends Component {
  constructor(props) {
    super()
    this.store = Store.fromJS()
    this.state = {
      selectedData: []
    }
  }

  componentDidMount() {
    const { exportConnectWebsocket } = this.store
    exportConnectWebsocket()
  }

  componentWillUnmount() {
    const { closeExportWebsocket } = this.store
    closeExportWebsocket()
  }

  onSelect = (data) => {
    this.setState({
      selectedData: data
    })
  }

  render() {
    const { store } = this
    return (
      <div className="statistics-page research-azf">
        <h2 className="page-title"><img alt="" src={statisticsIcon} />统计</h2>
        <div className="clearfix wrapper-box-first">
          <DataHeader store={store} selectedData={this.state.selectedData} />
        </div>
        <div>
          <DataTable store={store} onSelect={this.onSelect} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/research/azf/statistics/index.js